export default {
  title: "Factuur",

  input: {
    title: "Bewerk factuur gegevens",
    titlePaid: "Waneer is de factuur betaald",

    status: "Status",
    invoiceNumberManual: "Handmatig factuurnummer",
    invoiceNumber: "Factuurnummer",
    invoiceDate: "Factuur datum",
    dueDate: "Verloop datum",
    reminders: "Herinnering verloopt op",
    paidDate: "Betaald op",
  },

  olderReminders: "+ {{number}} oudere"
}
